import { Controller } from 'react-hook-form';
import { Textarea } from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { AdditionalInformationBlockTypes } from './types';
import { NewApplicationStatus } from '../../../../hoc/common/types';

import commonStyles from '../../common/styles.module.css';

const KeyContacts = ({
  applicationScheme,
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  isEditable,
  status,
}: AdditionalInformationBlockTypes) => (
  <StepPartBlock title="Key contacts">
    <>
      {applicationScheme?.mlroDetailsActive && (
        <InfoRow
          title="MLRO details"
          id="mlroDetails"
          className={commonStyles.noFlex}
          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="mlroDetails"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name="mlroDetails"
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['mlroDetails']);
                }}
                className="borderless"
                error={questionnarieErrors?.mlroDetails?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.complianceConsultantDetailsActive && (
        <InfoRow
          title="Compliance consultant details"
          id="complianceConsultantDetails"
          className={commonStyles.noFlex}

          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="complianceConsultantDetails"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name="complianceConsultantDetails"
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['complianceConsultantDetails']);
                }}
                className="borderless"
                error={
                  questionnarieErrors?.complianceConsultantDetails?.message
                }
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.accountantDetailsActive && (
        <InfoRow
          title="Accountant details"
          id="accountantDetails"
          className={commonStyles.noFlex}

          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="accountantDetails"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name="accountantDetails"
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['accountantDetails']);
                }}
                className="borderless"
                error={questionnarieErrors?.accountantDetails?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.itProviderDetailsActive && (
        <InfoRow
          title="IT provider details"
          id="itProviderDetails"
          className={commonStyles.noFlex}

          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="itProviderDetails"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name="itProviderDetails"
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['itProviderDetails']);
                }}
                className="borderless"
                error={questionnarieErrors?.itProviderDetails?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.payoutPartnerDetailsActive && (
        <InfoRow
          title="Pay out partner details"
          id="payoutPartnerDetails"
          className={commonStyles.noFlex}

          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="payoutPartnerDetails"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name="payoutPartnerDetails"
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['payoutPartnerDetails']);
                }}
                className="borderless"
                error={questionnarieErrors?.payoutPartnerDetails?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
    </>
  </StepPartBlock>
);

export default KeyContacts;
